import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import "./App.css";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import PortfolioDetail from "./pages/PortfolioDetail";
import Experience from "./pages/Experience";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Testimonials from "./pages/Testimonials";
import Certifications from "./pages/Certifications";
import CertificationDetail from "./pages/CertificationDetail";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { Toaster } from "./components/ui/toaster";
import ScrollToTop from "./components/ui/ScrollToTop";
import LogoutModal from "./components/ui/LogoutModal";

function App() {
  const [showSessionModal, setShowSessionModal] = useState(false);

  useEffect(() => {
    const handleJwtExpired = () => {
      setShowSessionModal(true);
    };

    window.addEventListener("jwtExpired", handleJwtExpired);
    return () => {
      window.removeEventListener("jwtExpired", handleJwtExpired);
    };
  }, []);
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen bg-background text-foreground">
            <Routes>
              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/*" element={<AdminDashboard />} />

              {/* Public routes */}
              <Route path="/*" element={
                <>
                  <Navbar />
                  <main className="flex-1">
                    <Routes>
                      <Route index element={<Home />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/portfolio" element={<Portfolio />} />
                      <Route path="/portfolio/:id" element={<PortfolioDetail />} />
                      <Route path="/experience" element={<Experience />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/blog" element={<Blog />} />
                      <Route path="/blog/:id" element={<BlogDetail />} />
                      <Route path="/testimonials" element={<Testimonials />} />
                      <Route path="/certifications" element={<Certifications />} />
                      <Route path="/certifications/:id" element={<CertificationDetail />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
          </div>
          <Toaster />
        </BrowserRouter>
        {showSessionModal && (
          <LogoutModal
            isOpen={showSessionModal}
            onClose={() => setShowSessionModal(false)}
            title="Session Expired"
            description="Your Session has expired. Please login again."
          />
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;